import React, { Fragment, useEffect } from 'react'
import ApplicationsLayout from './ApplicationsLayout'
import { useAuthState } from 'packages/core'
import useSubcomponents from 'useSubcomponents'
import { usePageContext } from 'pageContext'

const allFilters = [
    {
        name: 'OwnedByFilter',
        requireAccess: 'ResourceAdmin-OwnedApplications-Control',
        tabs: {
            applications: true,
            claimsMappingPolicies: false,
        },
    },
    {
        name: 'showOnlyAzureApplications',
        requireAccess: 'ResourceAdmin-showOnlyAzureApplications-Control',
        tabs: {
            applications: true,
            claimsMappingPolicies: false,
        },
    },
    {
        name: 'targetSystemFilter',
        requireAccess: 'ResourceAdmin-ApplicationsTargetSystem-Control',
        tabs: {
            applications: true,
            claimsMappingPolicies: true,
        },
    },
    {
        name: 'includeBasicClaimSet',
        requireAccess: 'ResourceAdmin-ApplicationsTargetSystem-Control',
        tabs: {
            applications: false,
            claimsMappingPolicies: true,
        },
    },
    {
        name: 'advancedSearch',
        requireAccess: 'ResourceAdmin-ApplicationsAdvancedSearch-Control',
        config: {
            title: 'Common_Forms',
            colorCode: {
                primary: '#2920ad',
                secondary: '#ebeaf7',
            },
            filters: [
                {
                    name: 'friendlyName',
                    type: 'text',
                    label: 'Common_Name',
                    placeholder: 'Common_Name',
                    contextProp: 'advancedSearch.forms.friendlyName',
                    requireAccess:
                        'ResourceAdmin-ApplicationFilters-AdvanceSearch-FriendlyName',
                },
                {
                    name: 'description',
                    type: 'text',
                    label: 'Common_Description',
                    placeholder: 'Common_Description',
                    contextProp: 'advancedSearch.forms.description',
                    requireAccess:
                        'ResourceAdmin-ApplicationFilters-AdvanceSearch-Description',
                },
            ],
            tags: {
                title: 'Common_Tags',
                colorCode: {
                    primary: '#f81983',
                    secondary: '#fee8f2',
                },
                contextProp: 'advancedSearchTags',
            },
        },
        tabs: {
            applications: true,
            claimsMappingPolicies: false,
        },
    },
    {
        name: 'advancedSearch',
        requireAccess: 'ResourceAdmin-ApplicationsAdvancedSearch-Control',
        config: {
            title: 'Common_Forms',
            colorCode: {
                primary: '#2920ad',
                secondary: '#ebeaf7',
            },
            filters: [
                {
                    name: 'friendlyName',
                    type: 'text',
                    label: 'FriendlyName',
                    placeholder: 'FriendlyName',
                    contextProp: 'advancedSearch.forms.friendlyName',
                },
                {
                    name: 'name',
                    type: 'text',
                    label: 'TechnicalName',
                    placeholder: 'TechnicalName',
                    contextProp: 'advancedSearch.forms.technicalName',
                },
            ],
            tags: {
                title: 'Common_Tags',
                colorCode: {
                    primary: '#f81983',
                    secondary: '#fee8f2',
                },
                contextProp: 'advancedSearchTags',
            },
        },
        tabs: {
            applications: false,
            claimsMappingPolicies: true,
        },
    },
]

const RequestViewAllApplications = () => {
    const [, dispatch] = usePageContext()
    const [{ currentUserId, friendlyName }] = useAuthState()

    const { trimControlsBasedOnAccess } = useSubcomponents()

    const filters = trimControlsBasedOnAccess(allFilters)
    const hasOwnedByFilterAccess =
        filters.map((f) => f.name).indexOf('OwnedByFilter') >= 0
    useEffect(() => {
        if (!hasOwnedByFilterAccess) {
            dispatch({
                type: 'SET_MULTIPLE_PROPS',
                payload: {
                    ownedBy: {
                        id: currentUserId,
                        friendlyName: friendlyName,
                    },
                    enableOwnedByApiCall: true,
                },
            })
        } else {
            dispatch({
                type: 'SET_PROP',
                payload: {
                    key: 'enableOwnedByApiCall',
                    value: true,
                },
            })
        }
    }, [currentUserId])

    return (
        <Fragment>
            <ApplicationsLayout _filters={filters} />
        </Fragment>
    )
}

export { RequestViewAllApplications }
